/* eslint-disable global-require */
import React from 'react';
import { tp } from 'app/utils/typograf';

export const slidesConfig = {
    hochland: [
        {
            id: '4741',
            isLineBreakStrict: true,
            title: '',
            titleXS: <>
                Паста с курицей, беконом
                <br />
                и творожным сыром Hochland
            </>,
            titleS: <>
                Паста с курицей, беконом
                и творожным сыром Hochland
            </>,
            titleM: <>
                Паста с курицей, беконом
                и творожным сыром Hochland
            </>,
            titleL: <>
                Паста с курицей, беконом
                и творожным сыром Hochland
            </>,
            src: 'https://rutube.ru/play/embed/3822687ef4cd9c57010b9eadf5ebc9ab/?p=ZyhM5PKMTlUhlswv2kMWag',
            bg: require('./img/hochland/4741.jpg'),
        },
        {
            id: '4748',
            isLineBreakStrict: true,
            titleXS: <>
                Киш с беконом и
                <br />
                сливочным плавленым сыром Hochland
            </>,
            titleS: <>
                Киш с беконом и
                <br />
                сливочным плавленым сыром Hochland
            </>,
            titleM: <>
                Киш с беконом и
                <br />
                сливочным плавленым сыром Hochland
            </>,
            titleL: <>
                Киш с беконом
                <br />
                и сливочным плавленым сыром Hochland
            </>,
            src: 'https://rutube.ru/play/embed/a325d4bf3f67b254688526062f26f724/?p=f5qldHvAKPVXzzEAtqCheg',
            bg: require('./img/hochland/4748.jpg'),
        },
        {
            id: '4749',
            titleXS: <>
                Конвертики из тортильи
                <br />
                с вялеными томатами и плавленым сыром Hochland
            </>,
            titleS: <>
                Конвертики из тортильи
                <br />
                с вялеными томатами и плавленым сыром Hochland
            </>,
            titleM: <>
                Конвертики
                <br />
                из тортильи с вялеными томатами и плавленым сыром Hochland
            </>,
            titleL: <>
                Конвертики из тортильи с вялеными томатами и плавленым сыром Hochland
            </>,
            isLineBreakStrict: true,
            src: 'https://rutube.ru/play/embed/d78a0fe910870e3b1d016e1d845c9a5a/?p=WhJXqve0SIiTbQ4jpfhGqw',
            bg: require('./img/hochland/4749.jpg'),
        },
        {
            id: '4750',
            title: 'Завтрак Омлет-ролл с травами и творожным сыром Hochland',
            src: 'https://rutube.ru/play/embed/f7386d55c6d30721a0862004cdbe3235/?p=DU59-G0j0aNlxQo3wkenYA',
            bg: require('./img/hochland/4750.jpg'),
        },
    ],
    maslenitsa: [
        {
            isLineBreakStrict: true,
            id: '4233',
            src: 'https://rutube.ru/play/embed/a80d28edf2e700e323a64f692efdadd9/?p=lj0X58cSVSFais39PjlSBQ',
            bg: require('./img/halloween/first_video_halloween.jpg'),
            titleXXS: <>
                Чёрно-черничная галета с сыром
                {' '}
                <br />
                {' '}
                и розмарином
            </>,
            titleXS: <>
                Чёрно-черничная галета с сыром
                {' '}
                <br />
                {' '}
                и розмарином
            </>,
            titleS: <>
                Чёрно-черничная галета
                <br />
                с сыром и розмарином
            </>,
            titleM: <>
                Чёрно-черничная галета
                <br />
                с сыром и розмарином
            </>,
            titleL: <>
                Чёрно-черничная галета
                <br />
                с сыром и розмарином
            </>,
        },
        {
            isLineBreakStrict: true,
            id: '4232',
            src: 'https://rutube.ru/play/embed/a215ec891acc946548f0162cbd71eb71/?p=kznGw5ttfJYeq81AtD2nHg',
            bg: require('./img/halloween/third_video_halloween.jpg'),
            titleXXS: <>
                Мини-пиццы с чоризо,
                <br />
                {' '}
                беконом и моцареллой
            </>,
            titleXS: <>
                Мини-пиццы
                <br />
                с чоризо, беконом
                <br />
                {' '}
                и моцареллой
            </>,
            titleS: <>
                Мини-пиццы с чоризо,
                <br />
                {' '}
                беконом и моцареллой
            </>,
            titleM: <>
                Мини-пиццы с чоризо,
                <br />
                {' '}
                беконом и моцареллой
            </>,
            titleL: <>
                Мини-пиццы с чоризо,
                <br />
                {' '}
                беконом и моцареллой
            </>,
        },
        {
            isLineBreakStrict: true,
            id: '4240',
            src: 'https://rutube.ru/play/embed/f538e4cf27ecf0fc7e03697de8c6b867/?p=SJFrm95Y9Mo7K2SalqjSig',
            bg: require('./img/halloween/second_video_halloween.jpg'),
            titleXXS: <>
                Шоко-кукис
                <br />
                с сахарными глазами
            </>,
            titleXS: <>
                Шоко-кукис
                <br />
                с сахарными глазами
            </>,
            titleS: <>
                Шоко-кукис
                <br />
                с сахарными глазами
            </>,
            titleM: <>
                Шоко-кукис
                <br />
                с сахарными глазами
            </>,
            titleL: <>
                Шоко-кукис
                <br />
                с сахарными глазами
            </>,
        },
        {
            isLineBreakStrict: true,
            id: '4234',
            src: 'https://rutube.ru/play/embed/3bfbcdad80e38d2c251f996c9a79548c/?p=jcu7tYHrraBOodDJzod--A',
            bg: require('./img/halloween/fourth_video_halloween.jpg'),
            titleXXS: <>
                Вунш-пунш
                <br />
                {' '}
                от ведьмы Аси
            </>,
            titleXS: <>
                Вунш-пунш
                <br />
                {' '}
                от ведьмы Аси
            </>,
            titleS: <>
                Вунш-пунш
                <br />
                {' '}
                от ведьмы Аси
            </>,
            titleM: <>
                Вунш-пунш
                <br />
                {' '}
                от ведьмы Аси
            </>,
            titleL: <>
                Вунш-пунш
                <br />
                {' '}
                от ведьмы Аси
            </>,
        },
    ],
    romantic: [
        {
            id: '4233',
            src: 'https://rutube.ru/play/embed/300dbc4bdde6a69bb946d1c5cf760afa/?p=znKaBQBCZ7RpDw1bTqVa9g',
            bg: require('./img/romantic/first_video.jpg'),
        },
        {
            id: '4240',
            src: 'https://rutube.ru/play/embed/ee1370b3a9b317db86409e78eed4e96c/?p=kVYBeq8TY67CXaogosxAcw',
            bg: require('./img/romantic/second_video.jpg'),
        },
        {
            id: '4232',
            src: 'https://rutube.ru/play/embed/95bcfc6c636f1e47ede5617ba5d587f0/?p=FYSzBBdfLgdsxtD-EphvEg',
            bg: require('./img/romantic/third_video.jpg'),
        },
        {
            id: '4234',
            src: 'https://rutube.ru/play/embed/45d62c6a7edf4352785ffd4b144c3c30/?p=MHsKDDIVYaLfd4AW5VbByg',
            bg: require('./img/romantic/fourth_video.jpg'),
        },
    ],
    kozelbezalkoholu: [
        {
            id: '4233',
            title: 'Куриные стрипсы в кляре',
            src: 'https://rutube.ru/play/embed/29dc7eb45551b5d3c98bbe78065a1f14/',
            bg: require('./img/kozel/first.jpg'),
        },
        {
            id: '4240',
            title: 'Бургеры из говядины с соусом барбекю',
            src: 'https://rutube.ru/play/embed/9703212dc4cb1f1348fafc457bae0789/',
            bg: require('./img/kozel/second.jpg'),
        },
        {
            id: '4232',
            title: 'Мясное жаркое',
            src: 'https://rutube.ru/play/embed/938e93ea5911d39ee903da3d17d3ab65/',
            bg: require('./img/kozel/third.jpg'),
        },
        {
            id: '4234',
            title: 'Биркейк с копчёностями',
            src: 'https://rutube.ru/play/embed/2e6cea1d83e9ff32280857d08771bf93/',
            bg: require('./img/kozel/fourth.jpg'),
        },
    ],
    halloween: [
        {
            isLineBreakStrict: true,
            id: '4233',
            src: 'https://rutube.ru/play/embed/a80d28edf2e700e323a64f692efdadd9/?p=lj0X58cSVSFais39PjlSBQ',
            bg: require('./img/halloween/first_video_halloween.jpg'),
            titleXXS: <>
                Чёрно-черничная галета с сыром
                {' '}
                <br />
                {' '}
                и розмарином
            </>,
            titleXS: <>
                Чёрно-черничная галета с сыром
                {' '}
                <br />
                {' '}
                и розмарином
            </>,
            titleS: <>
                Чёрно-черничная галета
                <br />
                с сыром и розмарином
            </>,
            titleM: <>
                Чёрно-черничная галета
                <br />
                с сыром и розмарином
            </>,
            titleL: <>
                Чёрно-черничная галета
                <br />
                с сыром и розмарином
            </>,
        },
        {
            isLineBreakStrict: true,
            id: '4232',
            src: 'https://rutube.ru/play/embed/a215ec891acc946548f0162cbd71eb71/?p=kznGw5ttfJYeq81AtD2nHg',
            bg: require('./img/halloween/third_video_halloween.jpg'),
            titleXXS: <>
                Мини-пиццы с чоризо,
                <br />
                {' '}
                беконом и моцареллой
            </>,
            titleXS: <>
                Мини-пиццы
                <br />
                с чоризо, беконом
                <br />
                {' '}
                и моцареллой
            </>,
            titleS: <>
                Мини-пиццы с чоризо,
                <br />
                {' '}
                беконом и моцареллой
            </>,
            titleM: <>
                Мини-пиццы с чоризо,
                <br />
                {' '}
                беконом и моцареллой
            </>,
            titleL: <>
                Мини-пиццы с чоризо,
                <br />
                {' '}
                беконом и моцареллой
            </>,
        },
        {
            isLineBreakStrict: true,
            id: '4240',
            src: 'https://rutube.ru/play/embed/f538e4cf27ecf0fc7e03697de8c6b867/?p=SJFrm95Y9Mo7K2SalqjSig',
            bg: require('./img/halloween/second_video_halloween.jpg'),
            titleXXS: <>
                Шоко-кукис
                <br />
                с сахарными глазами
            </>,
            titleXS: <>
                Шоко-кукис
                <br />
                с сахарными глазами
            </>,
            titleS: <>
                Шоко-кукис
                <br />
                с сахарными глазами
            </>,
            titleM: <>
                Шоко-кукис
                <br />
                с сахарными глазами
            </>,
            titleL: <>
                Шоко-кукис
                <br />
                с сахарными глазами
            </>,
        },
        {
            isLineBreakStrict: true,
            id: '4234',
            src: 'https://rutube.ru/play/embed/3bfbcdad80e38d2c251f996c9a79548c/?p=jcu7tYHrraBOodDJzod--A',
            bg: require('./img/halloween/fourth_video_halloween.jpg'),
            titleXXS: <>
                Вунш-пунш
                <br />
                {' '}
                от ведьмы Аси
            </>,
            titleXS: <>
                Вунш-пунш
                <br />
                {' '}
                от ведьмы Аси
            </>,
            titleS: <>
                Вунш-пунш
                <br />
                {' '}
                от ведьмы Аси
            </>,
            titleM: <>
                Вунш-пунш
                <br />
                {' '}
                от ведьмы Аси
            </>,
            titleL: <>
                Вунш-пунш
                <br />
                {' '}
                от ведьмы Аси
            </>,
        },
    ],
    maxim: [
        {
            id: '4233',
            src: 'https://rutube.ru/play/embed/a80d28edf2e700e323a64f692efdadd9/?p=lj0X58cSVSFais39PjlSBQ',
            bg: require('./img/maxim/first_video_maxim.jpg'),
        },
        {
            id: '4240',
            src: 'https://rutube.ru/play/embed/f538e4cf27ecf0fc7e03697de8c6b867/?p=SJFrm95Y9Mo7K2SalqjSig',
            bg: require('./img/maxim/second_video_maxim.jpg'),
        },
        {
            id: '4232',
            src: 'https://rutube.ru/play/embed/a215ec891acc946548f0162cbd71eb71/?p=kznGw5ttfJYeq81AtD2nHg',
            bg: require('./img/maxim/third_video_maxim.jpg'),
        },
        {
            id: '4234',
            src: 'https://rutube.ru/play/embed/3bfbcdad80e38d2c251f996c9a79548c/?p=jcu7tYHrraBOodDJzod--A',
            bg: require('./img/maxim/fourth_video_maxim.jpg'),
        },
    ],
    hp: [
        {
            id: 'puding',
            src: 'https://rutube.ru/play/embed/f5f211e5d9171ebaa27efbbf7669c991/?p=3mCflkgQgNMEWkjXoGyWlQ',
            bg: require('./img/hp/puding.jpg'),
        },
        {
            id: '4234',
            src: 'https://rutube.ru/play/embed/ecd48032a837955467fc4e2c718af4f5/?p=cgEd7PmKX671s4gg7vS6oA',
            bg: require('./img/hp/chicken.jpg'),
        },
        {
            id: 'cake',
            src: 'https://rutube.ru/play/embed/8aaca9c57621f40ec303d79224633b42/?p=NYfuoJ_cvqjTF6udYItEVw',
            bg: require('./img/hp/cake.jpg'),
        },

        {
            id: '4232',
            src: 'https://rutube.ru/play/embed/6cd64fd8347397e5ff2dc3d8530e4804/?p=m-hk6Xo9F0waxKYPbHT_eg',
            bg: require('./img/hp/cookies.jpg'),
        },
    ],
    ny: [
        {
            id: 'first_ny',
            src: 'https://rutube.ru/play/embed/607b1e6e304e02428aed54cf851d3728/?p=Q5biDrra26rs5tBEyZpIrw',
            bg: require('./img/ny/first_ny.jpg'),
            title: 'Утка по-мандарински',
        },
        {
            id: 'second_ny',
            src: 'https://rutube.ru/play/embed/67c955534faf857309733332f71d2f52/',
            bg: require('./img/ny/second_ny.jpg'),
            title: 'Оливье с томлёной уткой',
        },
        {
            id: 'third_ny',
            src: 'https://rutube.ru/play/embed/7522dcebd08cd60f99c512a0bbc17418/?p=8am9JF96x9A5-VbGQjQ5jg',
            bg: require('./img/ny/third_ny.jpg'),
            title: 'Глазированный лосось',
        },
        {
            id: 'fourth_ny',
            src: 'https://rutube.ru/play/embed/486e6fbbe0683705135026c43c6b32e9/?p=37q2SjvzjikMPvmIqH46rg',
            bg: require('./img/ny/fourth_ny.jpg'),
            title: 'Имбирная коврижка «Рождественский венок»',
        },
        {
            id: 'fifth_ny',
            src: 'https://rutube.ru/play/embed/00b2066012d6d606d77f86c9d4170218/?p=QcrXhz9eKlFtEt7HZERT1A',
            bg: require('./img/ny/fifth_ny.jpg'),
            title: 'Трио тартинок с сыром',
        },
    ],
    marchgifts: [
        {
            id: 'marchgifts',
            src: 'https://rutube.ru/play/embed/b403455afe71eb59ed24e33ad6b3ff17/?p=WYqyJ_j6SMNRSCUntd6P1w',
        },
    ],
    easterbox: [
        {
            id: 'easterbox1',
            src: 'https://rutube.ru/play/embed/e83fd61be463480fed8a2c73fea7bbe1/?p=au2yHx4kyrZX7rLwUbwvZg',
            bg: require('./img/easterbox/easterbox1.jpg'),
        },
        {
            id: 'easterbox2',
            src: 'https://rutube.ru/play/embed/d69fc6911600082c5f803e63d704a1ab/?p=hVAiX7T2bTtv1i3sO3kP7g',
            bg: require('./img/easterbox/easterbox2.jpg'),
        },
        {
            id: 'easterbox3',
            src: 'https://rutube.ru/play/embed/df49561ae94a459941ced6aa1c7acddc/?p=EtTQh5MMHxwkBEf3Jp9O0Q',
            bg: require('./img/easterbox/easterbox3.jpg'),
        },
        {
            id: 'easterbox4',
            src: 'https://rutube.ru/play/embed/bf64de953182ad7b3f833354e2619724/?p=nVWPR8j4FUzh749P9ghypA',
            bg: require('./img/easterbox/easterbox4.jpg'),
        },
    ],
    // katya: [
    //     {
    //         id: 'review_1',
    //         src: 'https://static.elementaree.ru/vid/review_1.mp4',
    //         bg: require('./img/katya/_slide_3.jpg'),
    //         isLineBreakStrict: true,
    //         titleXXS: <>
    //             Спагетти &quot;5 злаков&quot;
    //             <br />
    //             с индейкой, кремчизом и тимьяном
    //         </>,
    //         titleXS: <>
    //             Спагетти &quot;5 злаков&quot;
    //             <br />
    //             с индейкой, кремчизом и тимьяном
    //         </>,
    //         titleS: <>
    //             Спагетти &quot;5 злаков&quot;
    //             <br />
    //             с индейкой, кремчизом и тимьяном
    //         </>,
    //         titleM: <>
    //             Спагетти &quot;5 злаков&quot;
    //             <br />
    //             с индейкой, кремчизом и тимьяном
    //         </>,
    //         titleL: <>
    //             Спагетти &quot;5 злаков&quot;
    //             <br />
    //             с индейкой, кремчизом и тимьяном
    //         </>,
    //     },
    //     {
    //         id: 'review_2',
    //         src: 'https://static.elementaree.ru/vid/bowl-main.mp4',
    //         bg: require('./img/katya/_slide_4.jpg'),
    //         isLineBreakStrict: true,
    //         titleXXS: <>
    //             Боул с лососем
    //             <br />
    //             и авокадо
    //         </>,
    //         titleXS: <>
    //             Боул с лососем
    //             <br />
    //             и авокадо
    //         </>,
    //         titleS: <>
    //             Боул с лососем
    //             <br />
    //             и авокадо
    //         </>,
    //         titleM: <>
    //             Боул с лососем
    //             <br />
    //             и авокадо
    //         </>,
    //         titleL: <>
    //             Боул с лососем
    //             <br />
    //             и авокадо
    //         </>,
    //     },
    //     {
    //         id: 'review_3',
    //         src: 'https://static.elementaree.ru/vid/review_3.mp4',
    //         bg: require('./img/katya/_slide_2.jpg'),
    //         isLineBreakStrict: true,
    //         titleXXS: <>
    //             Спагетти Болоньезе
    //             <br />
    //             с говядиной
    //         </>,
    //         titleXS: <>
    //             Спагетти Болоньезе
    //             <br />
    //             с говядиной
    //         </>,
    //         titleS: <>
    //             Спагетти Болоньезе
    //             <br />
    //             с говядиной
    //         </>,
    //         titleM: <>
    //             Спагетти Болоньезе
    //             <br />
    //             с говядиной
    //         </>,
    //         titleL: <>
    //             Спагетти Болоньезе
    //             <br />
    //             с говядиной
    //         </>,
    //     },
    //     {
    //         id: 'review_4',
    //         src: 'https://static.elementaree.ru/vid/review_4.mp4',
    //         bg: require('./img/katya/_slide_5.jpg'),
    //         isLineBreakStrict: true,
    //         titleXXS: <>
    //             Лазанья Болоньезе
    //             <br />
    //             с говядиной и готовыми соусами
    //         </>,
    //         titleXS: <>
    //             Лазанья Болоньезе
    //             <br />
    //             с говядиной и готовыми соусами
    //         </>,
    //         titleS: <>
    //             Лазанья Болоньезе
    //             <br />
    //             с говядиной и готовыми соусами
    //         </>,
    //         titleM: <>
    //             Лазанья Болоньезе
    //             <br />
    //             с говядиной и готовыми соусами
    //         </>,
    //         titleL: <>
    //             Лазанья Болоньезе
    //             <br />
    //             с говядиной и готовыми соусами
    //         </>,
    //     },
    // ],
    ecomilk: [
        {
            id: 'review_1',
            src: 'https://static.elementaree.ru/vid/bagel.mp4',
            bg: require('./img/ecomilk/bagel.jpg'),
            isLineBreakStrict: true,
            titleXXS: <>{tp.execute('Бейгл с лососем и сыром Экомилк')}</>,
            titleXS: <>{tp.execute('Бейгл с лососем и сыром Экомилк')}</>,
            titleS: <>{tp.execute('Бейгл с лососем и сыром Экомилк')}</>,
            titleM: <>{tp.execute('Бейгл с лососем и сыром Экомилк')}</>,
            titleL: <>{tp.execute('Бейгл с лососем и сыром Экомилк')}</>,

        },
        {
            id: 'review_2',
            src: 'https://static.elementaree.ru/vid/croissant.mp4  ',
            bg: require('./img/ecomilk/croissant.jpg'),
            isLineBreakStrict: true,
            titleXXS: <>{tp.execute('Круассан с творожным сыром Экомилк, ванильной грушей и карамелизированным фундуком')}</>,
            titleXS: <>{tp.execute('Круассан с творожным сыром Экомилк, ванильной грушей и карамелизированным фундуком')}</>,
            titleS: <>{tp.execute('Круассан с творожным сыром Экомилк, ванильной грушей и карамелизированным фундуком')}</>,
            titleM: <>{tp.execute('Круассан с творожным сыром Экомилк, ванильной грушей и карамелизированным фундуком')}</>,
            titleL: <>{tp.execute('Круассан с творожным сыром Экомилк, ванильной грушей и карамелизированным фундуком')}</>,

        },
        {
            id: 'review_3',
            src: 'https://static.elementaree.ru/vid/pasta.mp4',
            bg: require('./img/ecomilk/pasta.jpg'),
            isLineBreakStrict: true,
            titleXXS: <>{tp.execute('Нежная сливочная паста с цыплёнком и сыром Экомилк')}</>,
            titleXS: <>{tp.execute('Нежная сливочная паста с цыплёнком и сыром Экомилк')}</>,
            titleS: <>{tp.execute('Нежная сливочная паста с цыплёнком и сыром Экомилк')}</>,
            titleM: <>{tp.execute('Нежная сливочная паста с цыплёнком и сыром Экомилк')}</>,
            titleL: <>{tp.execute('Нежная сливочная паста с цыплёнком и сыром Экомилк')}</>,
        },
        {
            id: 'review_4',
            src: 'https://static.elementaree.ru/vid/potato_cake.mp4  ',
            bg: require('./img/ecomilk/potato_cake.jpg'),
            isLineBreakStrict: true,
            titleXXS: <>{tp.execute('Картофельный тарт с горгонзолой и творожным сыром Экомилк')}</>,
            titleXS: <>{tp.execute('Картофельный тарт с горгонзолой и творожным сыром Экомилк')}</>,
            titleS: <>{tp.execute('Картофельный тарт с горгонзолой и творожным сыром Экомилк')}</>,
            titleM: <>{tp.execute('Картофельный тарт с горгонзолой и творожным сыром Экомилк')}</>,
            titleL: <>{tp.execute('Картофельный тарт с горгонзолой и творожным сыром Экомилк')}</>,

        },
        {
            id: 'review_5',
            src: 'https://static.elementaree.ru/vid/salad.mp4',
            bg: require('./img/ecomilk/salad.jpg'),
            isLineBreakStrict: true,
            titleXXS: <>{tp.execute('Салат из рукколы со свеклой и сыром Экомилк')}</>,
            titleXS: <>{tp.execute('Салат из рукколы со свеклой и сыром Экомилк')}</>,
            titleS: <>{tp.execute('Салат из рукколы со свеклой и сыром Экомилк')}</>,
            titleM: <>{tp.execute('Салат из рукколы со свеклой и сыром Экомилк')}</>,
            titleL: <>{tp.execute('Салат из рукколы со свеклой и сыром Экомилк')}</>,
        },
    ],
};


